import React, { useState } from 'react';
import { api } from '../api';
import InstallModal from './InstallModal';

export default function Auth({ onAuth }) {
  const [mode, setMode] = useState('register'); // 'login' | 'register'
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showInstall, setShowInstall] = useState(false);

  const switchMode = (m) => {
    setMode(m);
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (mode === 'register' && password !== confirmPassword) {
      setError('Пароли не совпадают');
      return;
    }
    setLoading(true);
    try {
      const payload = mode === 'register' ? { username, password, confirmPassword, email: email || undefined } : { username, password };
      const result = mode === 'register'
        ? await api.register(payload)
        : await api.login(payload);
      onAuth(result);
    } catch (err) {
      setError(err.message || 'Что-то пошло не так');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-screen">
      <div className="auth-content">
        <div className="auth-logo">🐷</div>
        <h1 className="auth-title">
          {mode === 'register' ? 'Управляй своими финансами онлайн' : 'С возвращением!'}
        </h1>
        <p className="auth-subtitle">
          {mode === 'register'
            ? 'Умный инструмент для планирования бюджета и учёта трат в одном месте'
            : 'Войди, чтобы продолжить вести учёт'}
        </p>

        <form className="auth-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <input
              type="text"
              placeholder="Имя пользователя"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              required
            />
          </div>
          <div className="form-group">
            <input
              type="password"
              placeholder="Пароль"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete={mode === 'register' ? 'new-password' : 'current-password'}
              required
            />
          </div>
          {mode === 'register' && (
            <div className="form-group">
              <input
                type="password"
                placeholder="Повторите пароль"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                autoComplete="new-password"
                required
              />
            </div>
          )}

          {mode === 'register' && (
            <div className="form-group">
              <input
                type="email"
                placeholder="E-mail (необязательно)"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
              />
              <small className="muted">Если забудете доступ, напишите на webneo@list.ru с этого адреса.</small>
            </div>
          )}

          {error && <div className="auth-error">{error}</div>}

          <button type="submit" className="auth-btn" disabled={loading}>
            {loading ? 'Подождите...' : mode === 'register' ? 'Начать' : 'Войти'}
          </button>
        </form>

        <div className="auth-switch">
          {mode === 'register' ? (
            <>Уже есть аккаунт? <button type="button" className="link-btn" onClick={() => switchMode('login')}>Войти</button></>
          ) : (
            <>Нет аккаунта? <button type="button" className="link-btn" onClick={() => switchMode('register')}>Зарегистрироваться</button></>
          )}
        </div>

        {mode === 'login' && (
          <div className="auth-recovery">
            <h4>Восстановление доступа</h4>
            <p className="muted">Если вы указывали e-mail при регистрации, напишите с этого адреса на <a href="mailto:webneo@list.ru">webneo@list.ru</a> с темой «Забыли доступ» и укажите ваше имя пользователя. Если вы не указывали e-mail, откройте <button type="button" className="link-btn" onClick={() => window.dispatchEvent(new Event('open:profile'))}>Профиль</button>, добавьте почту и затем напишите в поддержку.</p>
          </div>
        )}

        <div className="auth-store">
          <button type="button" className="store-btn store-play" onClick={() => setShowInstall(true)}>
            <svg className="store-icon" viewBox="0 0 512 512">
              <path d="M325.3 234.3L104.6 13l280.8 161.2-60.1 60.1zM47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0zm425.2 225.6l-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM104.6 499l280.8-161.2-60.1-60.1L104.6 499z"/>
            </svg>
            <span className="store-text"><small>Установить через</small><b>Google Play</b></span>
          </button>
          <button type="button" className="store-btn store-apple" onClick={() => setShowInstall(true)}>
            <svg className="store-icon" viewBox="0 0 384 512">
              <path d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"/>
            </svg>
            <span className="store-text"><small>Загрузите в</small><b>App Store</b></span>
          </button>
        </div>
      </div>
      {showInstall && <InstallModal onClose={() => setShowInstall(false)} />}
    </div>
  );
}
